export default __webpack_public_path__ + "static/media/protecto_poster.ecaa7175.png";